/*
 * Public API Surface of fulltext-search-pipe
 */

export * from './lib/fulltext-search-pipe';
export * from './lib/fulltext-search-pipe.module';
